module.exports = __webpack_public_path__ + "static/media/header-language.aff319d5.png";